import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../RecoilStates";
import { UseComment } from "./UseComment";
import CustomPagination from "../../components/CustomPagination";
import CheckIcon from "@mui/icons-material/Check";
import HttpsIcon from "@mui/icons-material/Https";
import LockOpenIcon from "@mui/icons-material/LockOpen";

export default function CommentsGrid(props) {
  const { MyNewComments, MyProductComments, ProductComments } = UseComment();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [commentsRes, setCommentsRes] = useState();

  useEffect(() => {
    if (props.getComment == 1) {
      setProgress(true);
      MyNewComments(props.pageState, true, (comments) => {
        props.setRefresh(false);
        setCommentsRes(comments);
        props.setDetailCom();
      });
    } else if (props.getComment == 2) {
      setProgress(true);
      MyProductComments(props.pageState, (comments) => {
        setCommentsRes(comments);
        props.setRefresh(false);
      });
    } else if (
      props.getComment == 3 &&
      (props.searchModel.Mobile ||
        props.searchModel.ProductID ||
        props.searchModel.ArticleID ||
        props.searchModel.CommentID)
    ) {
      setProgress(true);
      ProductComments(
        props.pageState,
        props.searchModel.Mobile,
        props.searchModel.ProductID,
        props.searchModel.ArticleID,
        props.searchModel.CommentID,
        (comments) => {
          setCommentsRes(comments);
          props.setRefresh(false);
        }
      );
    } else if (
      props.getComment == 3 &&
      (props.searchModel.Mobile == "" ||
        props.searchModel.ProductID ||
        props.searchModel.ArticleID ||
        props.searchModel.CommentID == "")
    ) {
      props.setRefresh(false);
      setCommentsRes();
    }
  }, [
    props.getComment,
    props.searchColumn,
    props.searchModel,
    props.pageState,
    props.refresh,
  ]);

  const columns = [
    {
      field: "select",
      width: 1,
      align: "center",
      headerName: "",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {props.detailCom && cellValues.row.id == props.detailCom.id ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              ""
            )}
          </Box>
        );
      },
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "shamsiDate",
      headerName: "تاریخ",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
            }}
          >
            {cellValues.row.shamsiDate}
          </Typography>
        );
      },
    },
    {
      field: "typeName",
      width: 120,
      align: "center",
      headerName: "نوع",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "صفحه",
      width: 250,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "userName",
      headerName: "نام و نام خانوادگی",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.userName}
          </Typography>
        );
      },
    },

    // {
    //   field: "mobile",
    //   width: 140,
    //   align: "center",
    //   headerName: "شماره موبایل",
    //   headerAlign: "center",
    // },

    {
      field: "وضعیت",
      sortable: false,
      width: 100,
      headerAlign: "center",
      align: "center",
      headerName: "وضعیت",
      renderCell: (cellValues) => {
        return (
          <>
            {cellValues.row.totalIsPrivate == false ? (
              <Tooltip title="غیرخصوصی">
                <IconButton sx={{ p: 0, mr: 2 }}>
                  <LockOpenIcon
                    sx={{
                      color: "primary.main",
                    }}
                    // fontSize="small"
                  />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="خصوصی">
                <IconButton sx={{ p: 0, mr: 2 }}>
                  <HttpsIcon
                    sx={{
                      color: "secondary.main",
                    }}
                    // fontSize="small"
                  />
                </IconButton>
              </Tooltip>
            )}
            {/* <Tooltip title="نمایش">
              <Button
                color="secondary"
                variant="contained"
                onClick={() => {
                  props.setMsScrollComment(true);
                  props.callBYID(cellValues.row.id);
                }}
              >
                نمایش
              </Button>
            </Tooltip> */}
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "33rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={commentsRes ? commentsRes.items : []}
        pageSize={commentsRes ? commentsRes.pageCondition.pageCount : 20}
        paginationMode="server"
        page={props.pageState - 1}
        Pagination
        onPageChange={(newPage) => {
          props.setPageState(newPage + 1);
        }}
        rowCount={commentsRes ? commentsRes.pageCondition.totalItemCount : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .MuiDataGrid-cell:hover": {
            opacity: "80%",
            cursor: "pointer",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
          "& .primary": {
            width: "100%",
            backgroundColor: "#e6d0ff !important",
          },
          "& .none": {
            width: "100%",
            backgroundColor: "#fff !important",
          },
          "& .gray": {
            width: "100%",
            backgroundColor: "#e8e8e8b5 !important",
          },
          "& .Green": {
            backgroundColor: "#56ff004f !important",
          },
          "& .red": {
            backgroundColor: "#ff9c9c !important",
          },
        }}
        getRowClassName={(params) => {
          if (params.row.totalState == 1) {
            return "Green";
          } else if (params.row.totalState == 2) {
            return "red";
          } else if (
            params.row.totalState == 0 &&
            params.row.typeName !== "محصول"
          ) {
            return "gray";
          }
        }}
        componentsProps={{
          pagination: {
            nofab: true,
            isLtr: true,
            rowCount: commentsRes?.pageCondition?.totalItemCount,
          },
        }}
        onRowClick={(row, cellValues) => {
          props.setMsScrollComment(true);
          props.callBYID(row.row.id);
        }}
      />
    </Box>
  );
}
